import { Observable } from "rxjs";
import { ConfirmModalComponent } from "../components/confirm-modal/confirm-modal.component";
import { map } from "rxjs/operators";
import { Injectable } from "@angular/core";
import { ModalService } from "./modal.service";

@Injectable({
	providedIn: "root"
})
export class ConfirmModalService {
	public constructor(private modalService: ModalService) {}

	public showConfirmModal(
		titleKey: string,
		textKey: string,
		buttonYesKey: string = "",
		buttonNoKey: string = "",
		showCloseButton: boolean = false,
		backdropDismiss: boolean = false,
		backButtonRoleDismiss: boolean = false
	): Observable<boolean> {
		const inputs = { titleKey: titleKey, data: textKey };
		if (buttonYesKey) {
			inputs["buttonYesKey"] = buttonYesKey;
		}
		if (buttonNoKey) {
			inputs["buttonNoKey"] = buttonNoKey;
		}

		const modal = this.modalService.create(ConfirmModalComponent, inputs, {
			showCloseButton: showCloseButton,
			backdropDismiss: backdropDismiss,
			backButtonRoleDismiss: backButtonRoleDismiss
		});
		modal.present();

		return modal.onDismiss.pipe(map((data) => data.role === "confirm"));
	}
}
